<script setup lang="ts"></script>

<template>
  <div></div>
</template>

<style module lang="scss"></style>
